import { getApiErrorMessage } from '../../utils/apiError';

/**
 * Operator-facing messages for supplier-order commands. Backend prose can
 * mention implementation details (FIFO or margin), so stable codes must be
 * translated here before they reach an OPERATIONS user.
 */
const SUPPLIER_ORDER_ERROR_CODE_KEYS: Record<string, string> = {
  SUPPLIER_ORDER_INVOICED_LINE_REMOVAL_BLOCKED: 'orders:supplierOrders.detail.invoicedLineRemovalBlocked',
  SUPPLIER_ORDER_INVOICED_DELETE_BLOCKED: 'orders:supplierOrders.detail.invoicedDeleteBlocked',
  SUPPLIER_ORDER_INVALID_STATUS_TRANSITION: 'orders:supplierOrders.detail.invalidStatusTransition',
  SUPPLIER_ORDER_PZ_REDUCTION_BLOCKED: 'orders:supplierOrders.detail.pzReductionBlocked',
  SUPPLIER_ORDER_PZ_LINE_REMOVAL_BLOCKED: 'orders:supplierOrders.detail.pzLineRemovalBlocked',
};

/**
 * Codes describing a state the operator must change before the command can
 * ever succeed (a line referenced by an approved invoice or received on a PZ).
 * Their toasts stay on screen until dismissed, like the PZ/WZ blocking codes.
 */
const SUPPLIER_ORDER_BLOCKING_CODES = new Set([
  'SUPPLIER_ORDER_INVOICED_LINE_REMOVAL_BLOCKED',
  'SUPPLIER_ORDER_INVOICED_DELETE_BLOCKED',
  'SUPPLIER_ORDER_INVALID_STATUS_TRANSITION',
  'SUPPLIER_ORDER_PZ_REDUCTION_BLOCKED',
  'SUPPLIER_ORDER_PZ_LINE_REMOVAL_BLOCKED',
]);

export function isBlockingSupplierOrderError(error: any): boolean {
  const code = error?.response?.data?.code;
  return typeof code === 'string' && SUPPLIER_ORDER_BLOCKING_CODES.has(code);
}

export function getSupplierOrderErrorMessage(
  error: any,
  t: any,
  fallbackKey: string,
  fallbackParams?: Record<string, unknown>,
): string {
  const code = error?.response?.data?.code;
  if (typeof code === 'string' && SUPPLIER_ORDER_ERROR_CODE_KEYS[code]) {
    return t(SUPPLIER_ORDER_ERROR_CODE_KEYS[code], fallbackParams);
  }
  return getApiErrorMessage(error, t, fallbackKey, undefined, fallbackParams);
}
